import React from "react"
import { Alert, Input } from "reactstrap"
import { Button } from "components/Button"

const AuditItemModal = ({
    onChange,
    value,
    isLoading,
    onSubmit,
    max,
    quantityWarning = false,
}) => {
    return (
        <form onSubmit={onSubmit}>
            <div className="d-flex align-items-center justify-content-center flex-column">
                <Input
                    onKeyDown={e => preventUnwantedInput(e)}
                    required
                    type="number"
                    value={value}
                    onChange={onChange}
                    step={"0.01"}
                    min={0}
                    max={max}
                />
                {/* {quantityWarning && (
                    <Alert
                        color="warning"
                        tag="span"
                        className="p-0 px-1 mb-0 mt-1 fs-12 text-left align-self-start"
                    >
                        Quantity exceeds max quantity
                    </Alert>
                )} */}
                <div>
                    <Button
                        title="Update"
                        type="submit"
                        className="gt-btn-grad-primary mt-2"
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </form>
    )
}

export default AuditItemModal
